import React from "react";
import { Box, useTheme, IconButton, CircularProgress } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link,  useNavigate } from 'react-router-dom';

import {  useGetWebsiteInterestQuery } from "state/api";
import { Header } from "components";

// Customers
const WebsiteInterest = () => {
  // theme
  const theme = useTheme();
  const navigate = useNavigate();
  // get data
  const { data, isLoading } = useGetWebsiteInterestQuery();

  // data columns
  const columns = [
  

    {
      field: "name",
      headerName: "Name",
      flex: 0.5,
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
    },
    {
      field: "interest",
      headerName: "Selected Interests",
      flex: 0.5,
    },
    {
        // field: 'createdAt',
        headerName: "Created At",
        flex: 0.5,
        valueGetter: (params) => {
            const date = new Date(params.row.createdAt);
            return date.toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true,
            });
        },
    }
  

  ];

  return (
    <Box m="1.5rem 2.5rem">
      {/* Header */}
      <Header title="WEBSITE INTERESTS" subtitle="List of people who have shown interest on the Quellr website." />

      {/* Content */}
      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButtom-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        {/* Grid table */}
        {isLoading ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <CircularProgress size="medium" style={{ width: 20, height: 20, color: 'white' }} />
          </Box>
        ) : (
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            {data && data.length > 0 ? (
              <DataGrid
                loading={isLoading || !data}
                getRowId={(row) => row._id}
                rows={data || []}
                columns={columns}
                sx={{ width: '100%' }}
              />
            ) : (
              <h1>No website interests found</h1>
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default WebsiteInterest;
